<div class="grid">
  <img
    src="https://lassedesk.top/al-media/alphabees_logo.svg"
    alt="Logo"
    class="logo"
  />
  <h2>{{ "pages.notFound.title" | translate }}</h2>
</div>
